import { render, staticRenderFns } from "./solicitacao.vue?vue&type=template&id=2e9938ae&scoped=true"
import script from "./solicitacao.vue?vue&type=script&lang=js"
export * from "./solicitacao.vue?vue&type=script&lang=js"
import style0 from "./solicitacao.vue?vue&type=style&index=0&id=2e9938ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9938ae",
  null
  
)

export default component.exports